/**
 * IoT / EdgeNexus API Services (pm/iot/*)
 * Every function resolves with the response body ({status, message, data, ...}).
 * HTTP errors (401/403/500) resolve as {status: "failed", message} so screens can
 * show them; the shared apiClient still handles login expiry and project setup.
 */
import { apiGet, apiPost, apiPostFormData } from "../../../api";

const body = (promise) =>
  promise
    .then((res) => res.data)
    .catch((err) =>
      err?.data?.status
        ? err.data
        : {
            status: "failed",
            message: err?.data?.message || err?.message || "There is backend issue, please contact administrator",
          }
    );

const get = (url) => (params, config) => body(apiGet(url, params, config));
const post = (url) => (data) => body(apiPost(url, data));

// ==================== Configuration ====================
export const addControlCategory = post("/pm/iot/add_control_category");
export const getControlCategory = get("/pm/iot/get_control_category");
export const updateControlCategory = post("/pm/iot/update_control_category");
export const deleteControlCategory = post("/pm/iot/delete_control_category");
export const checkParameterFormat = get("/pm/iot/check_parameter_format");
export const addSubControlCategory = post("/pm/iot/add_sub_control_category");
export const getSubControlCategory = get("/pm/iot/get_sub_control_category");
export const updateDeleteSubControlCategory = post("/pm/iot/update_delete_sub_control_category");
export const getControlCategoryWithSubCategories = get("/pm/iot/get_control_category_with_sub_categories");
export const addProcessControlParameter = post("/pm/iot/add_process_control_parameter");
export const getProcessControlParameter = get("/pm/iot/get_process_control_parameter");
export const updateProcessControlParameter = post("/pm/iot/update_process_control_parameter");
export const deleteProcessControlParameter = post("/pm/iot/delete_process_control_parameter");
export const bulkUploadProcessControlParameter = (formData) =>
  body(apiPostFormData("/pm/iot/bulk_upload_process_control_parameter", formData));
export const getIotAssetGroupSummary = get("/pm/iot/get_iot_asset_group_summary");
export const getMachineIotSettings = get("/pm/iot/get_machine_iot_settings");
export const updateMachineIotSettings = post("/pm/iot/update_machine_iot_settings");
export const resyncMachineSubscription = post("/pm/iot/resync_machine_subscription");
export const getIotDropdowns = get("/pm/iot/get_iot_dropdowns");

// ==================== Live data, PLC ====================
export const getMachineLiveValues = get("/pm/iot/get_machine_live_values");
export const getParameterHistory = get("/pm/iot/get_parameter_history");
export const getMachinePlcAccess = get("/pm/iot/get_machine_plc_access");
export const toggleMachinePlcAccessMode = post("/pm/iot/toggle_machine_plc_access_mode");
export const writeProcessControlValue = post("/pm/iot/write_process_control_value");
export const getIotIntegrationStatus = get("/pm/iot/get_iot_integration_status");
export const getIotAuditLog = get("/pm/iot/get_iot_audit_log");
export const getIotAlarms = get("/pm/iot/get_iot_alarms");

// ==================== Notifications ====================
export const getIotNotifications = get("/pm/iot/get_iot_notifications");
export const getIotNotificationCount = get("/pm/iot/get_iot_notification_count");
export const markIotNotificationsRead = post("/pm/iot/mark_iot_notifications_read");

// ==================== Dashboards ====================
export const getIotDashboardOverview = get("/pm/iot/dashboard/overview");
export const getIotLiveParameters = get("/pm/iot/dashboard/live_parameters");
export const getIotMachineDashboard = get("/pm/iot/dashboard/machine");
export const getIotCategoryComparison = get("/pm/iot/dashboard/category_comparison");
export const getIotAlarmAnalytics = get("/pm/iot/dashboard/alarm_analytics");
export const getIotRuntimeSummary = get("/pm/iot/dashboard/runtime_summary");
